export const CORE_BUNDLE_ID = 'core-bundle';
